import styled from 'styled-components';

import { Loader, LoaderSize } from '@dreryk/react-components';

const StyledPatientLoader = styled.div`
   height: 100%;
   width: 100%;
   display: flex;
   justify-content: center;
   align-items: center;
`;

StyledPatientLoader.displayName = 'StyledPatientLoader';

const PatientLoader = (): JSX.Element => (
   <StyledPatientLoader>
      <Loader size={LoaderSize.BIG} testId={'loader'} />
   </StyledPatientLoader>
);

export { PatientLoader };
